import { TextColorNames } from "@smartsuite/react-ui";
import styled from "styled-components";

export const Text = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  justify-content: flex-start;
`;

export const ImportText = styled(Text)`
  margin-left: 10px;
`;

export const GrayedText = styled(Text)`
  color: ${TextColorNames.tertiary};
`;

export const Input = styled.div`
  width: 270px;
`;

export const ApplicationTile = styled.div`
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
`;

export const IconWrapper = styled.span``;

export const Footer = styled.div`
  padding: 5px 10px 15px 10px;
  display: flex;
  cursor: pointer;
`;

export const Space = styled.div`
  margin-left: 8px;
`;

export const HR = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #000000;
  opacity: 10%;
  padding: 0;
`;

export const PlaceholderWrapper = styled.div`
  position: absolute;
  top: 8px;
  z-index: 1010;
  background-color: white;
  margin-left: 3px;
`;
